export default () => {
    const videos = document.querySelectorAll('.sustainability__block--inherit-video');
    const contentBlocks = document.querySelectorAll('.sus-5050__wrapper:has(.sus-5050__inheritor) .sus-5050');

    const mergedPairs = Array.from(videos).map((video, index) => ({
        video,
        contentBlock: contentBlocks[index],
    }));

    const calculateStickyProgress = (element) => {
        if (!element) return 0;

        const parent = element.parentElement;
        const parentRect = parent.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        //console.log(parentRect.top, elementRect.top, parentRect.bottom, elementRect.bottom);

        // if parentRect.top is equal to elementRect.top, then the element is locked at the top of the parent
        if (parentRect.top === elementRect.top) {
            return 0;
        }

        // if parentRect.bottom is equal to elementRect.bottom, then the element is locked at the bottom of the parent
        if (parentRect.bottom === elementRect.bottom) {
            return 1;
        }

        // if neither then the element is sticking
        const distanceToTravel = parent.offsetHeight - element.offsetHeight;
        const progress = (elementRect.top - parentRect.top) / distanceToTravel;

        return progress;
    };

    const handleScroll = () => {
        mergedPairs.forEach((pair) => {
            if (!pair.video || !pair.contentBlock) return;

            // calculate the progress of the video and the content block
            const videoProgress = calculateStickyProgress(pair.video);
            pair.video.style.setProperty('--progress', videoProgress.toFixed(2));
            const contentProgress = calculateStickyProgress(pair.contentBlock);
            pair.contentBlock.style.setProperty('--progress', contentProgress.toFixed(2));

            //console.log('--------------------------------');
            //console.log('Video progress:', videoProgress);

            // calculate the progress between the video and the content block
            if (videoProgress === 1 && contentProgress === 0) {
                const contentRect = pair.contentBlock.parentElement.getBoundingClientRect();
                const contentTopOffset = parseFloat(getComputedStyle(pair.contentBlock).top);

                const distanceToTravel = pair.video.offsetHeight;
                const distanceLeft = contentRect.top - contentTopOffset;
                const cropProgress = 1 - distanceLeft / distanceToTravel;
                pair.video.style.setProperty('--crop-progress', cropProgress.toFixed(2));

                //console.log('Crop progress:', cropProgress);
            }

            //console.log('Content progress:', contentProgress);
        });
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });

    const handleResize = () => {
        videos.forEach((video) => {
            video.parentElement.style.setProperty('--video-size', `${video.offsetHeight}px`);
        });
    };
    window.addEventListener('resize', handleResize, { passive: true });
};
